import L from 'leaflet';

import { MAP_GLYPHS } from '@/shared/ui';
import type { LocationType } from '@/entities/dashboard/mapping';

// Fix for default marker icon issue in Leaflet with Webpack
L.Icon.Default.mergeOptions({
  iconRetinaUrl: undefined,
  iconUrl: undefined,
  shadowUrl: undefined
});

const LOCATION_COLORS: Record<string, string> = {
  /** blue-500 */
  W: '#3b82f6',
  /** green-500 */
  P: '#10b981',
  /** orange-500 */
  C: '#f97316',
  /** purple-500 */
  S: '#a855f7'
};

const LOCATION_GLYPHS: Record<string, string> = {
  W: MAP_GLYPHS.warehouse,
  P: MAP_GLYPHS.anchor,
  C: MAP_GLYPHS.users,
  S: MAP_GLYPHS.building
};

/**
 * Legacy draws a port by what kind of port it is rather than by the generic anchor
 * (`mapping.js:545-551`, `portTypeClasses`). The codes are the backend's:
 * 1 airport, 2 seaport, 3 helipad, 4 rail terminal, 5 river port.
 */
const PORT_TYPE_GLYPHS: Record<number, string> = {
  1: MAP_GLYPHS.plane,
  2: MAP_GLYPHS.anchor,
  3: MAP_GLYPHS.helicopter,
  4: MAP_GLYPHS.train,
  5: MAP_GLYPHS.sailboat
};

const createSvgIcon = (glyph: string, color: string) =>
  L.divIcon({
    html: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${glyph}</svg>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12],
    className: 'custom-svg-icon'
  });

export const getLocationIcon = (type: LocationType | string, portType?: number) => {
  const portGlyph = type === 'P' && portType !== undefined ? PORT_TYPE_GLYPHS[portType] : undefined;
  const glyph = portGlyph || LOCATION_GLYPHS[type] || MAP_GLYPHS.users;

  return createSvgIcon(glyph, LOCATION_COLORS[type] || '#6b7280');
};
